(function () {
  function getHero() {
    return document.querySelector('.password-hero');
  }


  function closeHero() {
    const hero = getHero();
    if (!hero) return;
    hero.style.right = '-100%';
    hero.classList.remove('is-active');
  }


  function showSuccess() {
    const success = document.getElementById('password-success');
    const warning = document.getElementById('password-warning');

    if (warning) warning.style.display = 'none';
    if (success) success.style.display = 'block';
    setTimeout(() => {
      if (success) success.style.display = 'none';
      closeHero();
    }, 1500);
    setTimeout(() => {
      window.location.href = '/cart';
    }, 1000);
  }




  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(res => {
      if (!res.ok) throw new Error('Add to cart failed');
      showSuccess();
    })
    .catch(() => {
      alert('Unable to add product to cart.');
    });
  }




  function handlePasswordSubmit(e) {
    const form = e.target.closest('.storefront-password-form');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const input = form.querySelector('input[name="password"]');
    const warning = document.getElementById('password-warning');
    const success = document.getElementById('password-success');

    if (!input || !warning) return;
    if (success) success.style.display = 'none';
    const entered = input.value.trim();
    const actual = window.__PRODUCT_PASSWORD__;

    if (!actual) {
      warning.textContent = 'Password not configured for this product.';
      warning.style.display = 'block';
      return;
    }

    // Safely get values, default to empty string if null/undefined
    const enteredValue = (entered || '').trim().toLowerCase();
    const actualValue = (actual || '').trim().toLowerCase();

    if (enteredValue && actualValue && enteredValue === actualValue) {
      warning.style.display = 'none';
      addToCart(window.__PRODUCT_VARIANT_ID__);
      localStorage.setItem('productPassword', entered);
    } else {
      warning.style.display = 'block';
    }
  }






  function init() {
    document.addEventListener('submit', handlePasswordSubmit, true);
  }



  
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();